var _ellipse, _g, _g2, _g3, _path, _circle, _circle2, _g4, _rect, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 155,
    viewBox: "0 0 199 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 183.52 62.9697)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15260_85710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 37,
    width: 131,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 43,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 47.5498C105.1 46.9975 104.652 46.5498 104.1 46.5498H50.1001C49.5478 46.5498 49.1001 46.9975 49.1001 47.5498V50.5498C49.1001 51.1021 49.5478 51.5498 50.1001 51.5498H104.1C104.652 51.5498 105.1 51.1021 105.1 50.5498V47.5498Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1 47.5498C127.1 46.9975 126.652 46.5498 126.1 46.5498H112.1C111.548 46.5498 111.1 46.9975 111.1 47.5498V50.5498C111.1 51.1021 111.548 51.5498 112.1 51.5498H126.1C126.652 51.5498 127.1 51.1021 127.1 50.5498V47.5498Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1 47.5498C150.1 46.9975 149.652 46.5498 149.1 46.5498H134.1C133.548 46.5498 133.1 46.9975 133.1 47.5498V50.5498C133.1 51.1021 133.548 51.5498 134.1 51.5498H149.1C149.652 51.5498 150.1 51.1021 150.1 50.5498V47.5498Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 37.25,
    width: 130.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_15260_85710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 65.1001,
    width: 131,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 71.1001,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 75.6499C105.1 75.0976 104.652 74.6499 104.1 74.6499H50.1001C49.5478 74.6499 49.1001 75.0976 49.1001 75.6499V78.6499C49.1001 79.2022 49.5478 79.6499 50.1001 79.6499H104.1C104.652 79.6499 105.1 79.2022 105.1 78.6499V75.6499Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1 75.6499C127.1 75.0976 126.652 74.6499 126.1 74.6499H112.1C111.548 74.6499 111.1 75.0976 111.1 75.6499V78.6499C111.1 79.2022 111.548 79.6499 112.1 79.6499H126.1C126.652 79.6499 127.1 79.2022 127.1 78.6499V75.6499Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1 75.6499C150.1 75.0976 149.652 74.6499 149.1 74.6499H134.1C133.548 74.6499 133.1 75.0976 133.1 75.6499V78.6499C133.1 79.2022 133.548 79.6499 134.1 79.6499H149.1C149.652 79.6499 150.1 79.2022 150.1 78.6499V75.6499Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 65.3501,
    width: 130.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_15260_85710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 93.2002,
    width: 131,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 99.2002,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 103.75C105.1 103.198 104.652 102.75 104.1 102.75H50.1001C49.5478 102.75 49.1001 103.198 49.1001 103.75V106.75C49.1001 107.302 49.5478 107.75 50.1001 107.75H104.1C104.652 107.75 105.1 107.302 105.1 106.75V103.75Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1 103.75C127.1 103.198 126.652 102.75 126.1 102.75H112.1C111.548 102.75 111.1 103.198 111.1 103.75V106.75C111.1 107.302 111.548 107.75 112.1 107.75H126.1C126.652 107.75 127.1 107.302 127.1 106.75V103.75Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1 103.75C150.1 103.198 149.652 102.75 149.1 102.75H134.1C133.548 102.75 133.1 103.198 133.1 103.75V106.75C133.1 107.302 133.548 107.75 134.1 107.75H149.1C149.652 107.75 150.1 107.302 150.1 106.75V103.75Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 93.4502,
    width: 130.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.665 88.7032C126.019 88.7032 133.602 81.1199 133.602 71.7654C133.602 62.4109 126.019 54.8276 116.665 54.8276C107.31 54.8276 99.7268 62.4109 99.7268 71.7654C99.7268 81.1199 107.31 88.7032 116.665 88.7032ZM116.728 85.3763C124.21 85.3763 130.275 79.311 130.275 71.8291C130.275 64.3471 124.21 58.2818 116.728 58.2818C109.246 58.2818 103.181 64.3471 103.181 71.8291C103.181 79.311 109.246 85.3763 116.728 85.3763Z",
    fill: "#72A4FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.728,
    cy: 71.829,
    r: 13.5473,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15260_85710",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 58,
    width: 28,
    height: 28
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.728,
    cy: 71.829,
    r: 13.5473,
    fill: "#B5B5B5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15260_85710)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_15260_85710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.4998,
    y: 32,
    width: 131,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7498,
    y: 32.25,
    width: 130.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_15260_85710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.4998,
    y: 60.1001,
    width: 131,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6 70.6499C124.6 70.0976 124.152 69.6499 123.6 69.6499H109.6C109.048 69.6499 108.6 70.0976 108.6 70.6499V73.6499C108.6 74.2022 109.048 74.6499 109.6 74.6499H123.6C124.152 74.6499 124.6 74.2022 124.6 73.6499V70.6499Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7498,
    y: 60.3501,
    width: 130.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130.552,
    y: 84.332,
    width: 4.34303,
    height: 4.34303,
    transform: "rotate(-54.1608 130.552 84.332)",
    fill: "#5685D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.475 89.3551C134.188 88.2009 133.98 86.2618 134.992 84.8605C136.004 83.4593 137.91 83.0475 139.41 83.9062L161.789 96.7146C163.979 97.7611 163.637 100.46 161.221 103.805C158.678 107.326 156.126 107.893 154.668 106.573L135.475 89.3551Z",
    fill: "#72A4FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.028 84.1172L132.097 78.484C133.264 79.3267 133.526 80.9555 132.684 82.1222L131.666 83.5305C130.824 84.6972 129.195 84.9598 128.028 84.1172Z",
    fill: "#72A4FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15260_85710",
    x: 21,
    y: 37,
    width: 177.1,
    height: 32.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15260_85710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15260_85710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_15260_85710",
    x: 21,
    y: 65.1001,
    width: 177.1,
    height: 32.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15260_85710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15260_85710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_15260_85710",
    x: 21,
    y: 93.2002,
    width: 177.1,
    height: 32.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15260_85710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15260_85710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_15260_85710",
    x: 18.4998,
    y: 32,
    width: 177.1,
    height: 32.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15260_85710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15260_85710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_15260_85710",
    x: 18.4998,
    y: 60.1001,
    width: 177.1,
    height: 32.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15260_85710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15260_85710",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAnalysis);
export default __webpack_public_path__ + "static/media/empty-analysis.54a189d7.svg";
export { ForwardRef as ReactComponent };